import React, { useState, useEffect } from 'react';
import { db, collection, getDocs } from '../firebase';
import { useTeam } from '../contexts/TeamContext';
import { buildRoster, calculateRosterStats } from '../utils/roster';
import '../App.css';

const DivisionGenerator = () => {
  const { teamId, loading: teamLoading } = useTeam();
  const [players, setPlayers] = useState([]);
  const [selectedPlayers, setSelectedPlayers] = useState([]);
  const [teamA, setTeamA] = useState([]);
  const [teamB, setTeamB] = useState([]);

  useEffect(() => {
    if (!teamId) return;

    const fetchPlayers = async () => {
      try {
        const [playersSnapshot, membersSnapshot, matchesSnapshot] = await Promise.all([
          getDocs(collection(db, 'teams', teamId, 'players')),
          getDocs(collection(db, 'teams', teamId, 'members')),
          getDocs(collection(db, 'teams', teamId, 'matches')),
        ]);

        const roster = buildRoster(
          playersSnapshot.docs.map((d) => ({ id: d.id, ...d.data() })),
          membersSnapshot.docs.map((d) => ({ id: d.id, ...d.data() }))
        );
        const matches = matchesSnapshot.docs.map((d) => d.data());
        const rankedPlayers = calculateRosterStats(roster, matches).sort(
          (a, b) => Number(b.mvpPoints || 0) - Number(a.mvpPoints || 0)
        );

        setPlayers(rankedPlayers);
      } catch (error) {
        console.error('Error fetching players:', error);
      }
    };

    fetchPlayers();
  }, [teamId]);

  const handleSelectPlayer = (player) => {
    if (selectedPlayers.find((p) => p.key === player.key)) {
      setSelectedPlayers(selectedPlayers.filter((p) => p.key !== player.key));
      return;
    }
    setSelectedPlayers([...selectedPlayers, player]);
  };

  const generateTeams = async () => {
    const sortedSelected = [...selectedPlayers].sort(
      (a, b) => Number(b.mvpPoints || 0) - Number(a.mvpPoints || 0)
    );

    let teamAList = [];
    let teamBList = [];
    const pattern = 'abbaabbaabbaabba';

    sortedSelected.forEach((player, index) => {
      if (pattern[index % pattern.length] === 'a') {
        teamAList.push(player);
      } else {
        teamBList.push(player);
      }
    });

    setTeamA(teamAList);
    setTeamB(teamBList);
  };

  const initials = (name) => {
    if (!name) return '?';
    return name
      .trim()
      .split(/\s+/)
      .map((w) => w[0])
      .slice(0, 2)
      .join('')
      .toUpperCase();
  };

  const clearSelection = () => {
    setSelectedPlayers([]);
    setTeamA([]);
    setTeamB([]);
  };

  if (teamLoading) {
    return <div className="loading-screen">Ucitavanje tima...</div>;
  }

  return (
    <div className="division-container">
      <div className="section-header">
        <h2>Podjela timova</h2>
        <span className="section-badge">{selectedPlayers.length} odabrano</span>
      </div>

      <p style={{ marginBottom: 20, color: 'var(--text-2)' }}>
        Klikni na igrace koje zelis ukljuciti u novu utakmicu. Generator raspodjeljuje
        timove prema MVP bodovima za balansirane timove.
      </p>

      <div className="player-grid">
        {players.map((player) => {
          const isSelected = selectedPlayers.find((p) => p.key === player.key);
          return (
            <div
              key={player.key}
              className={`player-card ${isSelected ? 'selected' : ''}`}
              onClick={() => handleSelectPlayer(player)}
            >
              <div className="player-avatar">{initials(player.name)}</div>
              <span className="player-name">{player.name}</span>
            </div>
          );
        })}
      </div>

      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 20 }}>
        <button onClick={generateTeams} className="btn btn-primary btn-lg" disabled={selectedPlayers.length < 2}>
          Generiraj timove
        </button>
        {selectedPlayers.length > 0 && (
          <button onClick={clearSelection} className="btn btn-secondary btn-lg">
            Ponisti odabir
          </button>
        )}
      </div>

      {teamA.length > 0 && teamB.length > 0 && (
        <div className="teams-result">
          <div className="team-result-card team-a">
            <h3>Tim A</h3>
            <ul>
              {teamA.map((player) => (
                <li key={player.key}>{player.name}</li>
              ))}
            </ul>
          </div>
          <div className="team-result-card team-b">
            <h3>Tim B</h3>
            <ul>
              {teamB.map((player) => (
                <li key={player.key}>{player.name}</li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default DivisionGenerator;
